import clsx from 'clsx'
import {getSubscriptionSignUpUrl} from 'common/HelperFunctions'
import {AiLoginErrorState} from 'common/helpers/aiLoginError'

type Props = {
  error: AiLoginErrorState
  isSpecialDomain?: boolean
  onSignInWithEmail?: (email?: string) => void
}

const alertStyle = {
  background: 'rgba(239, 68, 68, 0.12)',
  border: '1px solid rgba(239, 68, 68, 0.35)',
  borderRadius: 12,
}

const buttonStyle = {
  background: '#3b82f6',
  color: '#fff',
  border: 'none',
  borderRadius: 10,
  padding: '10px 20px',
  fontSize: 14,
  fontWeight: 600,
}

/**
 * Case 1 (account_not_found) and Case 2 (use_email_password) alert UI
 * shared by universal login and tenant AI login pages.
 */
export function AiLoginErrorAlert({error, isSpecialDomain = true, onSignInWithEmail}: Props) {
  return (
    <div className='mb-8 alert' style={alertStyle}>
      <div
        className={clsx('alert-text font-weight-bold mb-4', isSpecialDomain ? 'text-white' : '')}
      >
        {error.message}
      </div>

      {error.step === 'account_not_found' ? (
        <a href={getSubscriptionSignUpUrl()} className='btn w-100' style={buttonStyle}>
          Sign Up
        </a>
      ) : null}

      {error.step === 'use_email_password' ? (
        <button
          type='button'
          className='btn w-100'
          style={buttonStyle}
          onClick={() => onSignInWithEmail?.(error.email)}
        >
          Sign In with Email
        </button>
      ) : null}
    </div>
  )
}
